import { PageHeader, Card, Tag, Button } from 'antd'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { getLeadDetails } from '../../network/MiniCRMs'
import Loader from '../../components/Loader'
import Error from '../../components/Error'
import { SCREEN_SIZE } from '../../constants/common'
import { createUrlWithFiltersFromCurrentURL } from '../../utils/filterUtils'
import moment from 'moment'
import { ROLE_PERMISSIONS } from '../../constants/common'
import { useAuth } from '../../hooks/useAuth'
import useIsMobile from '../../hooks/useIsMobile'

const ViewMiniCRM = ({ history }) => {
  const { leadId } = useParams()
  const isMobile = useIsMobile(SCREEN_SIZE.MOBILE)
  const { user } = useAuth()
  const permissions = ROLE_PERMISSIONS[user.role]
    ? ROLE_PERMISSIONS[user.role]
    : []

  const leadDetails = useQuery(
    [
      'getLeadDetails',
      {
        id: leadId,
      },
    ],
    getLeadDetails,
    {
      refetchOnWindowFocus: false,
    }
  )

  const getTypeTag = (type) => {
    const typeConfig = {
      'potential lead': { color: 'orange', label: 'Potential Lead' },
      'qualified lead': { color: 'green', label: 'Qualified Lead' },
    }
    const config = typeConfig[type] || { color: 'default', label: type }
    return <Tag color={config.color}>{config.label}</Tag>
  }

  const handleEdit = () => {
    const url = createUrlWithFiltersFromCurrentURL(`/mini-crm/${leadId}/edit`)
    const [pathname, search] = url.split('?')
    history.push({
      pathname,
      search: search ? `?${search}` : '',
      state: { fromDetail: true },
    })
  }

  const canEdit = permissions.includes('can-edit-leads')

  return (
    <>
      <PageHeader
        className="site-page-header"
        title="Lead Details"
        onBack={() => {
          const url = createUrlWithFiltersFromCurrentURL('/mini-crm')
          history.push(url)
        }}
        extra={
          canEdit && (
            <Button type="primary" onClick={handleEdit}>
              Edit
            </Button>
          )
        }
        style={{ backgroundColor: '#fff' }}
      />

      {leadDetails.isError ? (
        <Error retry={() => leadDetails.refetch()} />
      ) : leadDetails.isLoading ? (
        <Loader />
      ) : (
        <div
          className="section-from-vertical"
          style={{
            width: '100%',
            padding: isMobile ? '12px' : '12px 12px 0px 12px',
            backgroundColor: '#f0f2f5',
            minHeight: 'calc(100vh - 64px)',
          }}
        >
          <div className="section-from-horizontal">
            <Card
              size="small"
              title="Lead Information"
              style={{ flex: 1, width: isMobile ? '100%' : 'auto' }}
            >
              <p>
                <strong>First Name: </strong>
                {leadDetails.data?.firstName || '-'}
              </p>
              <p>
                <strong>Last Name: </strong>
                {leadDetails.data?.lastName || '-'}
              </p>
              <p>
                <strong>Type: </strong>
                {leadDetails.data?.type
                  ? getTypeTag(leadDetails.data.type)
                  : '-'}
              </p>
              <p>
                <strong>Note: </strong>
                <span
                  style={{
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    display: 'block',
                    marginTop: '4px',
                  }}
                >
                  {leadDetails.data?.note || '-'}
                </span>
              </p>
            </Card>
          </div>

          <div className="section-from-horizontal">
            <Card
              size="small"
              title="Additional Information"
              style={{ flex: 1, width: isMobile ? '100%' : 'auto' }}
            >
              {leadDetails.data?.createdAt && (
                <p>
                  <strong>Created At: </strong>
                  {moment(leadDetails.data.createdAt).format(
                    'YYYY-MM-DD HH:mm:ss'
                  )}
                </p>
              )}
              {leadDetails.data?.updatedAt && (
                <p>
                  <strong>Updated At: </strong>
                  {moment(leadDetails.data.updatedAt).format(
                    'YYYY-MM-DD HH:mm:ss'
                  )}
                </p>
              )}
              {leadDetails.data?.owner && (
                <p>
                  <strong>Owner: </strong>
                  {leadDetails.data.owner?.name ||
                    leadDetails.data.owner ||
                    '-'}
                </p>
              )}
            </Card>
          </div>
        </div>
      )}
    </>
  )
}

export default ViewMiniCRM
